import {DataType} from "../types/enums";

const URL_LIST_DATA_TYPE_TO_STATE: Record<string, DataType> = {
  profile: DataType.Correlations,
  correlations: DataType.Correlations,
  negative: DataType.Negative,
  positive: DataType.Positive,
};

const STATE_LIST_DATA_TYPE_TO_URL: Record<DataType, string> = {
  [DataType.Correlations]: "profile",
  [DataType.Negative]: "negative",
  [DataType.Positive]: "positive",
};

export const parseNumericParam = (value: string | null | undefined): number | undefined => {
  if (!value) return undefined;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
};

export const parseListDataTypeParam = (value: string | null | undefined): DataType | undefined => {
  if (!value) return undefined;
  return URL_LIST_DATA_TYPE_TO_STATE[value.toLowerCase()];
};

export const formatListDataTypeParam = (value: DataType): string => {
  return STATE_LIST_DATA_TYPE_TO_URL[value];
};
